import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApplicantdashboardserviceService } from './applicantdashboardservice.service';
import { DocumentHandlerService } from './document-handler.service';
import { forkJoin, throwError } from 'rxjs';
import { finalize, tap, catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { PdfDownloadService } from './pdf-download.service';
import { wassceGradeOptions } from './wassce-grades.data';
import { SessionService } from '../session.service';

@Component({
  selector: 'app-appdashboard',
  templateUrl: './appdashboard.component.html',
  styleUrls: ['./appdashboard.component.scss'],
})



export class AppdashboardComponent implements OnInit, OnDestroy, AfterViewInit {

  private hasUnsavedLocalChanges = false

  showSessionExpiredModal = false;
private sessionSubscription!: any;
private tokenCheckInterval: any;

  
  isGeneratingPDF = false;
  pdfDownloadService = new PdfDownloadService();

  showWassceOverlay = false; // Toggle for overlay visibility

    // Mobile stepper enhancements
  @ViewChild('stepperContainer') stepperContainer!: ElementRef;
  showScrollHint = true;


  ngAfterViewInit() {
  }


  wassceGradeOptions = wassceGradeOptions;

  selectedWassceGrades: string[] = [];

  loading: boolean = false;
  isSubmitting: boolean = false;

  submissionError: string | null = null;
  submissionSuccess: boolean = false;

  applicantTypeForm!: FormGroup;
  selectedApplicantType: 'SHS Graduate' | 'Diploma Holder' | 'Mature Applicant' | null = null;

  admissionRegistrationForm!: FormGroup;
  currentAdmissionStep: number = 0;
  maxAdmissionStepReached: number = 0;
  admissionPasswordVisible: boolean = false;
  admissionConfirmPasswordVisible: boolean = false;
  hasAdmissionHealthCondition: boolean | null = null;
  admissionUploadedFileName: string = '';

  passportPhotoUrl: string | ArrayBuffer | null = null;

  countries: any[] = [];
  availableStates: any[] = [];
  applicationStatus: string = '';

  isLoadingData: boolean = false;
  dataLoaded: boolean = false;

  private isInitialLoad = true;

  programmes: any[] = [];
  filteredProgrammes: any[] = [];
  selectedProgrammeType: string = '';
  isLoadingProgrammes: boolean = false;

  retrievedDocuments: any = {};
  isLoadingDocuments: boolean = false;

  secureImageUrls: { [key: string]: string } = {};
  documentLoadingStates: { [key: string]: boolean } = {};

  currentApplicantId: number | null = null;

  admissionSidebarSteps = [
    {
      icon: 'fas fa-id-card',
      title: 'Applicant Type',
      description: 'Select your application type',
    },
    {
      icon: 'fas fa-user',
      title: 'Personal Information',
      description: 'Basic personal details and demographics',
    },
    {
      icon: 'fas fa-map-marker-alt',
      title: 'Address & Contact',
      description: 'Postal address and contact information',
    },
    {
      icon: 'fas fa-graduation-cap',
      title: 'Programme & Health',
      description: 'Programme selection and health details',
    },
    {
      icon: 'fas fa-upload',
      title: 'Document Upload',
      description: 'Upload required documents',
    },
    {
      icon: 'fas fa-check-circle',
      title: 'Review & Submit',
      description: 'Review and submit application',
    },
    {
      icon: 'fas fa-info-circle',
      title: 'Application Status',
      description: 'View the status of your application',
    },
  ];

  admissionStepValidationGroups = {
    0: ['applicantType'],
    1: [
      'admissionTitle',
      'admissionSurname',
      'admissionFirstName',
      'admissionMiddleName',
      'admissionOtherNames',
      'admissionGender',
      'admissionDob',
      'admissionCountryOfBirth',
      'admissionCityOfBirth',
      'admissionNationality',
      'admissionReligion',
      'admissionHometown',
      'admissionRegion',
      'emergency_contact_name',
      'emergency_contact_phone',
      'emergency_contact_relationship',
      'previous_school',
      'wassce_index_number',
      'wassce_grades',
      'wassce_year',
      'core_subjects_aggregate',
      'elective_subjects_aggregate',
      'diploma_institution',
      'diploma_program',
      'diploma_class',
      'diploma_completion_year',
      'diploma_gpa',
      'work_experience',
      'years_of_experience',
      'current_employer',
    ],
    2: [
      'admissionAddressLine1',
      'admissionAddressLine2',
      'residential_address',
      'admissionCity',
      'admissionPostalStateRegion',
      'admissionCountry',
      'admissionPostalCodenDigitalAddress',
      'admissionTelephone',
      'alternate_phone',
    ],
    3: [
      'admissionProgramme',
      'programme_type',
      'preferred_study_mode',
      'academic_year',
      'admissionHealthCondition',
      'admissionHealthConditionDetails',
      'disabilities',
      'special_needs',
      'fee_payment_mode',
      'scholarship_applied',
      'scholarship_type',
      'other_qualifications',
      'professional_certifications',
      'language_proficiency',
    ],
    4: ['admissionPassportPhoto', 'admissionDocuments'],
    5: [],
    6: [],
  };


  getMobileProgressPercentage(): number {
  return ((this.currentAdmissionStep + 1) / this.admissionSidebarSteps.length) * 100;
}


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private applicantinfoservice: ApplicantdashboardserviceService,
    private documentHandler: DocumentHandlerService,
    private toaster: ToastrService,
    private cd: ChangeDetectorRef,
    private sessionService: SessionService

  ) {}


ngOnInit(): void {
  console.log('=== DASHBOARD COMPONENT INITIALIZED ===');
  console.log('🔍 Checking token availability...');
  console.log('  - sessionStorage.authToken:', !!sessionStorage.getItem('authToken'));
  console.log('  - localStorage.authToken:', !!localStorage.getItem('authToken'));
  console.log('  - localStorage.token:', !!localStorage.getItem('token'));
  
  this.initializeForms();
  const dataRestored = this.loadFormDataFromStorage();
  this.setupFormValidators();
  
  // This prevents "Failed to load application data" error on first login
  setTimeout(() => {
    console.log('🔄 Starting data load after delay...');
    const token = this.getAuthToken();
    //console.log('🔍 Token found:', !!token);
    
    if (token) {
      this.loadInitialData();
    } else {
      //console.error('❌ No token found after delay');
      this.toaster.error('Authentication token not found. Please log in again.', 'Authentication Error');
      this.isLoadingData = false;
      this.isInitialLoad = false;
    }
  }, 200); // 200ms delay to ensure sessionStorage is synchronized
  
   this.setupAutoSave(); 

  this.admissionRegistrationForm.get('wassce_grades')?.valueChanges.subscribe(() => {
    this.selectedWassceGrades = this.admissionRegistrationForm.get('wassce_grades')?.value || [];
  });



  // Listen for session expiry events
this.sessionSubscription = this.sessionService.sessionExpired$.subscribe(() => {
  this.showSessionExpiredModal = true;
  this.cd.detectChanges();
});

// Proactively check token every 60 seconds
this.tokenCheckInterval = setInterval(() => {
  if (this.sessionService.isTokenExpired()) {
    this.showSessionExpiredModal = true;
    this.cd.detectChanges();
    clearInterval(this.tokenCheckInterval);
  }
}, 60000);


}


  ngOnDestroy(): void {
    Object.values(this.secureImageUrls).forEach((url) => {
      if (url && url.startsWith('blob:')) {
        window.URL.revokeObjectURL(url);
      }
    });
    this.secureImageUrls = {};
  }

  private setupAutoSave(): void {
    this.admissionRegistrationForm.valueChanges.subscribe(() => {
      if (!this.isInitialLoad) {
        this.saveFormDataToStorage();
      }
    });

    this.applicantTypeForm.valueChanges.subscribe(() => {
      if (!this.isInitialLoad) {
        this.saveFormDataToStorage();
      }
    });

    this.sessionSubscription?.unsubscribe();
    clearInterval(this.tokenCheckInterval);
  }

  // form overlay selection and data persistence
  toggleWassceOverlay(): void {
    this.showWassceOverlay = !this.showWassceOverlay;
  }

  onWassceGradeToggle(grade: string, event: Event): void {
    event.stopPropagation(); // Prevent overlay close
    const gradesControl = this.admissionRegistrationForm.get('wassce_grades');
    const currentGrades: string[] = gradesControl?.value || [];
    if (currentGrades.includes(grade)) {
      gradesControl?.setValue(currentGrades.filter((g) => g !== grade));
    } else {
      gradesControl?.setValue([...currentGrades, grade]);
    }

    gradesControl?.updateValueAndValidity();
  }

  removeWassceGrade(grade: string): void {
    const gradesControl = this.admissionRegistrationForm.get('wassce_grades');
    const currentGrades: string[] = gradesControl?.value || [];
    gradesControl?.setValue(currentGrades.filter((g) => g !== grade));
  }

  closeWassceOverlay(): void {
    this.showWassceOverlay = false;
  }

  // Close on outside click (add to ngOnInit or use @HostListener)
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.showWassceOverlay) {
      const target = event.target as HTMLElement;
      if (!target.closest('.wassce-multiselect-container')) {
        this.closeWassceOverlay();
      }
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.showWassceOverlay) {
      this.closeWassceOverlay();
    }
  }

  private saveFormDataToStorage(): void {
    try {
      const formData = {
        admissionForm: this.admissionRegistrationForm.value,
        applicantTypeForm: this.applicantTypeForm.value,
        selectedApplicantType: this.selectedApplicantType,
        currentAdmissionStep: this.currentAdmissionStep,
        maxAdmissionStepReached: this.maxAdmissionStepReached,
        passportPhotoUrl: this.passportPhotoUrl,
        admissionUploadedFileName: this.admissionUploadedFileName,
        hasAdmissionHealthCondition: this.hasAdmissionHealthCondition,
        timestamp: Date.now(),
      };
      localStorage.setItem('admissionFormData', JSON.stringify(formData));
    } catch (error) {
      console.warn('Failed to save form data to localStorage:', error);
    }
  }

  private loadFormDataFromStorage(): boolean {
     try {
    const savedData = localStorage.getItem('admissionFormData');
    if (savedData) {
      const formData = JSON.parse(savedData);
      const isDataFresh = formData.timestamp && Date.now() - formData.timestamp < 24 * 60 * 60 * 1000;

      if (isDataFresh) {
        if (formData.admissionForm) {
           this.hasUnsavedLocalChanges = true
          const admissionData = { ...formData.admissionForm };

             admissionData.admissionPassportPhoto = null;
            admissionData.admissionDocuments = null;
          // Handle legacy string format for wassce_grades
          if (admissionData.wassce_grades && typeof admissionData.wassce_grades === 'string') {
            admissionData.wassce_grades = admissionData.wassce_grades
              .split(',')
              .map((s: any) => s.trim())  // FIXED: Added type annotation
              .filter((s: any) => s);     // FIXED: Also add type here for consistency
          }
          this.admissionRegistrationForm.patchValue(admissionData, {
            emitEvent: false,
          });
        }

          if (formData.applicantTypeForm) {
            this.applicantTypeForm.patchValue(formData.applicantTypeForm, {
              emitEvent: false,
            });
          }
          this.selectedApplicantType = formData.selectedApplicantType;
          this.currentAdmissionStep = formData.currentAdmissionStep || 0;
          this.maxAdmissionStepReached = formData.maxAdmissionStepReached || 0;
          this.passportPhotoUrl = formData.passportPhotoUrl;
          this.admissionUploadedFileName = formData.admissionUploadedFileName || '';
          this.hasAdmissionHealthCondition = formData.hasAdmissionHealthCondition;
          if (this.selectedApplicantType) {
            this.setValidatorsForApplicantType(this.selectedApplicantType);
          }

          return true;
        }
      }
    } catch (error) {
      console.warn('Failed to load form data from localStorage:', error);
    }
    return false;
  }

  private clearFormDataFromStorage(): void {
    localStorage.removeItem('admissionFormData');
  }

  private initializeForms(): void {
    this.applicantTypeForm = this.fb.group({
      applicantType: [null, Validators.required],
    });

    this.admissionRegistrationForm = this.fb.group({
      admissionTitle: ['', Validators.required],
      admissionSurname: ['', Validators.required],
      admissionFirstName: ['', Validators.required],
      admissionMiddleName: [''],
      admissionOtherNames: [''],
      admissionGender: ['', Validators.required],
      admissionDob: ['', Validators.required],
      admissionCountryOfBirth: ['', Validators.required],
      admissionCityOfBirth: ['', Validators.required],
      admissionNationality: ['', Validators.required],
      admissionReligion: [''],
      admissionHometown: ['', Validators.required],
      admissionRegion: ['', Validators.required],

      emergency_contact_name: [''],
      emergency_contact_phone: [''],
      emergency_contact_relationship: [''],

      admissionAddressLine1: ['', Validators.required],
      admissionAddressLine2: [''],
      residential_address: [''],
      admissionCity: ['', Validators.required],
      admissionPostalStateRegion: [''],
      admissionCountry: ['', Validators.required],
      admissionPostalCodenDigitalAddress: [''],
      admissionTelephone: ['', Validators.required],
      alternate_phone: [''],

      admissionProgramme: ['', Validators.required],
      programme_type: ['Undergraduate', Validators.required],
      preferred_study_mode: ['Full-time', Validators.required],
      academic_year: ['2025/2026', Validators.required],
      admissionHealthCondition: ['', Validators.required],
      admissionHealthConditionDetails: [''],
      disabilities: [''],
      special_needs: [''],
      fee_payment_mode: ['Full Payment', Validators.required],
      scholarship_applied: [false, Validators.required],
      scholarship_type: [''],
      other_qualifications: [''],
      professional_certifications: [''],
      language_proficiency: [''],

      admissionPassportPhoto: [null],
      admissionDocuments: [null],

      admissionEmail: ['', [Validators.email]],
      admissionPassword: ['', [Validators.minLength(6)]],
      admissionConfirmPassword: [''],

      previous_school: [null],
      wassce_index_number: [null],
      // wassce_grades: [null],
      wassce_grades: [[]],
      wassce_year: [null],
      core_subjects_aggregate: [null],
      elective_subjects_aggregate: [null],

      diploma_institution: [null],
      diploma_program: [null],
      diploma_class: [null],
      diploma_completion_year: [null],
      diploma_gpa: [null],

      mature_exam_status: [null],
      work_experience: [null],
      mature_exam_date: [null],
      years_of_experience: [null],
      current_employer: [null],
    });
  }

  private setupFormValidators(): void {
    this.admissionRegistrationForm.get('admissionHealthCondition')?.valueChanges.subscribe((value) => {
      this.hasAdmissionHealthCondition = value === 'Yes';
      const healthDetailsControl = this.admissionRegistrationForm.get('admissionHealthConditionDetails');
      if (value === 'Yes') {
        healthDetailsControl?.setValidators([Validators.required]);
      } else {
        healthDetailsControl?.clearValidators();
        healthDetailsControl?.reset();
      }
      healthDetailsControl?.updateValueAndValidity();
    });

    this.admissionRegistrationForm
      .get('admissionConfirmPassword')
      ?.setValidators([this.matchAdmissionPasswords.bind(this)]);
    this.admissionRegistrationForm.get('admissionPassword')?.valueChanges.subscribe(() => {
      this.admissionRegistrationForm.get('admissionConfirmPassword')?.updateValueAndValidity();
    });

    this.applicantTypeForm.get('applicantType')?.valueChanges.subscribe((value) => {
      if (this.isInitialLoad) {
        return;
      }
      this.onApplicantTypeChange(value);
    });

    // FIX 1: Handle Country of Birth changes (for Region field in Personal Info)
    this.admissionRegistrationForm.get('admissionCountryOfBirth')?.valueChanges.subscribe((countryName) => {
      this.onCountryOfBirthChange(countryName);
    });

    // FIX 2: ADD THIS - Handle Postal Country changes (for Postal State/Region in Address)
    this.admissionRegistrationForm.get('admissionCountry')?.valueChanges.subscribe((countryName) => {
      this.updatePostalStates(countryName);
    });

    this.admissionRegistrationForm.get('programme_type')?.valueChanges.subscribe((value) => {
      this.onProgrammeTypeChange(value);
    });
  }

  private updatePostalStates(countryName: string): void {
    console.log('Postal Country changed to:', countryName);

    if (countryName && this.countries?.length > 0) {
      const selectedCountry = this.countries.find((country) => country.name === countryName);
      console.log('Postal country object:', selectedCountry);

      this.availableStates = selectedCountry?.states || [];
      console.log('Available postal states:', this.availableStates);

      // Clear the postal state/region when country changes
      if (this.availableStates.length === 0) {
        this.admissionRegistrationForm.patchValue(
          {
            admissionPostalStateRegion: '',
          },
          { emitEvent: false }
        );
      }
    } else {
      this.availableStates = [];
      this.admissionRegistrationForm.patchValue(
        {
          admissionPostalStateRegion: '',
        },
        { emitEvent: false }
      );
    }
  }

  private loadInitialData(): void {
    this.isLoadingData = true;
    this.isInitialLoad = true;

    this.loadProgrammes();

    this.applicantinfoservice.getCountriesAndStates().subscribe({
     next: (res) => {
  this.countries = res.data;

  // ✅ Re-trigger regions if local data already loaded
  if (this.hasUnsavedLocalChanges) {
    const localCountryOfBirth = this.admissionRegistrationForm.get('admissionCountryOfBirth')?.value;
    const localRegion = this.admissionRegistrationForm.get('admissionRegion')?.value;
    const localPostalCountry = this.admissionRegistrationForm.get('admissionCountry')?.value;
    const localPostalRegion = this.admissionRegistrationForm.get('admissionPostalStateRegion')?.value;

    if (localCountryOfBirth) {
      this.onCountryOfBirthChange(localCountryOfBirth);
      setTimeout(() => {
        if (localRegion) {
          this.admissionRegistrationForm.patchValue(
            { admissionRegion: localRegion },
            { emitEvent: false }
          );
          this.cd.detectChanges();
        }
      }, 50);
    }

    if (localPostalCountry) {
      this.updatePostalStates(localPostalCountry);
      setTimeout(() => {
        if (localPostalRegion) {
          this.admissionRegistrationForm.patchValue(
            { admissionPostalStateRegion: localPostalRegion },
            { emitEvent: false }
          );
        }
      }, 50);
    }
  }

  this.loadApplicantDataWithRetry();
},
      error: (err) => {
        console.error('Failed to load countries:', err);
        this.isLoadingData = false;
        this.isInitialLoad = false;
        this.loadApplicantDataWithRetry();
      },
    });

    this.loadApplicationStatus();
    // this.loadProgrammes();
    this.loadRetrievedDocuments();
  }

  private loadApplicantDataWithRetry(retryCount: number = 0): void {
    const token = this.getAuthToken();
    if (!token) {
      this.isLoadingData = false;
      this.isInitialLoad = false;
      return;
    }

    this.applicantinfoservice.getApplicantData(token).subscribe({
      next: (data) => {
        this.populateFormData(data);
        this.dataLoaded = true;
        this.isLoadingData = false;
        this.isInitialLoad = false;
        setTimeout(() => {
          this.cd.detectChanges();
        });
      },
      error: (error) => {
        this.isLoadingData = false;
        this.isInitialLoad = false;
        setTimeout(() => {
          this.cd.detectChanges();
        });
        if (retryCount < 2) {
          setTimeout(() => {
            this.loadApplicantDataWithRetry(retryCount + 1);
          }, 1000 * (retryCount + 1));
        } else {
          this.toaster.error('Failed to load your application data. Please refresh the page.', 'Load Error');
        }
      },
    });
  }

  private populateFormData(data: any): void {
    if (this.isSubmittingFlag) {
      console.log('Skipping form population during submission');
      return;
    }
    console.log('Populating form with data:', data);

    if (!data) return;

if (this.hasUnsavedLocalChanges) {
  console.log('⚠️ Local unsaved changes detected - skipping server data overwrite');

  this.currentApplicantId = data.id?.applicantId || null;


if (data.filePaths?.academicTranscriptsPath) {
  this.admissionUploadedFileName = this.extractFileNameFromUrl(
    data.filePaths.academicTranscriptsPath
  );
}

  const localCountryOfBirth = this.admissionRegistrationForm.get('admissionCountryOfBirth')?.value;
  const localRegion = this.admissionRegistrationForm.get('admissionRegion')?.value;
  const localPostalCountry = this.admissionRegistrationForm.get('admissionCountry')?.value;
  const localPostalRegion = this.admissionRegistrationForm.get('admissionPostalStateRegion')?.value;
  const localProgrammeType = this.admissionRegistrationForm.get('programme_type')?.value;
  const localProgramme = this.admissionRegistrationForm.get('admissionProgramme')?.value;

  if (localCountryOfBirth && this.countries.length > 0) {
    this.onCountryOfBirthChange(localCountryOfBirth);
    setTimeout(() => {
      if (localRegion) {
        this.admissionRegistrationForm.patchValue(
          { admissionRegion: localRegion },
          { emitEvent: false }
        );
      }
      this.cd.detectChanges();
    }, 50);
  }

  if (localPostalCountry && this.countries.length > 0) {
    this.updatePostalStates(localPostalCountry);
    setTimeout(() => {
      if (localPostalRegion) {
        this.admissionRegistrationForm.patchValue(
          { admissionPostalStateRegion: localPostalRegion },
          { emitEvent: false }
        );
      }
    }, 50);
  }

  if (localProgrammeType && this.programmes.length > 0) {
    this.selectedProgrammeType = localProgrammeType;
    this.filterProgrammesByType(localProgrammeType);
    setTimeout(() => {
      if (localProgramme) {
        this.admissionRegistrationForm.patchValue(
          { admissionProgramme: localProgramme },
          { emitEvent: false }
        );
      }
    }, 100);
  }

  const localWassceGrades = this.admissionRegistrationForm.get('wassce_grades')?.value;
  if (localWassceGrades?.length > 0) {
    this.selectedWassceGrades = localWassceGrades;
  }

  return; // ✅ return is at the BOTTOM
}

    if (data.id?.applicantType) {
      this.selectedApplicantType = data.id?.applicantType;
      this.applicantTypeForm.patchValue({ applicantType: data.id?.applicantType }, { emitEvent: false });
      this.setValidatorsForApplicantType(data.id?.applicantType);
    }

    this.currentApplicantId = data.id?.applicantId || null;

    const formValues = {
      // Personal Info
      admissionTitle: data.personalInfo?.title || '',
      admissionSurname: data.personalInfo?.lastName || '',
      admissionFirstName: data.personalInfo?.firstName || '',
      admissionMiddleName: data.personalInfo?.middleName || '',
      admissionOtherNames: data.personalInfo?.othername || '',
      admissionDob: this.formatDate(data.personalInfo?.dateOfBirth),
      admissionGender: data.personalInfo?.gender || '',
      admissionNationality: data.personalInfo?.nationality || '',
      admissionEmail: data.contactInfo?.email || '',
      admissionTelephone: data.contactInfo?.phoneNumber || '',
      alternate_phone: data.contactInfo?.alternatePhone || '',

      // Contact Info
      admissionAddressLine1: data.contactInfo?.postalAddress || '',
      admissionAddressLine2: data.contactInfo?.postalAddresstwo || '',
      residential_address: data.contactInfo?.residentialAddress || '',
      admissionRegion: data.contactInfo?.region || '',
      admissionCity: data.contactInfo?.city || '',
      admissionPostalStateRegion: data.contactInfo?.postalStateRegion || '',
      admissionCountry: data.personalInfo?.postalcountry || '',
      admissionPostalCodenDigitalAddress: data.contactInfo?.postalCodendigaddress || '',
      admissionCountryOfBirth: data.personalInfo?.countryofbirth || '',
      admissionCityOfBirth: data.personalInfo?.cityortownofbirth || '',
      admissionReligion: data.personalInfo?.religion || '',
      admissionHometown: data.personalInfo?.hometown || '',

      // Emergency Contact
      emergency_contact_name: data.emergencyContact?.emergencyContactName || '',
      emergency_contact_phone: data.emergencyContact?.emergencyContactPhone || '',
      emergency_contact_relationship: data.emergencyContact?.emergencyContactRelationship || '',

      // Academic & Other Info
      admissionProgramme: data.academicInfo?.programmeAppliedFor || '',
      programme_type: data.academicInfo?.programmeType || 'Undergraduate',
      preferred_study_mode: data.academicInfo?.preferredStudyMode || 'Full-time',
      academic_year: data.academicInfo?.academicYear || '2025/2026',
      other_qualifications: data.academicInfo?.otherQualifications || '',
      professional_certifications: data.academicInfo?.professionalCertifications || '',
      language_proficiency: data.academicInfo?.languageProficiency || '',

      // Financial & Health Info
      fee_payment_mode: data.applicationDetails?.feePaymentMode || 'Full Payment',
      scholarship_applied: data.applicationDetails?.scholarshipApplied || false,
      scholarship_type: data.applicationDetails?.scholarshipType || '',
      admissionHealthCondition: data.applicationDetails?.medicalConditions ? 'Yes' : 'No',
      admissionHealthConditionDetails: data.applicationDetails?.medicalConditions || '',
      disabilities: data.applicationDetails?.disabilities || '',
      special_needs: data.applicationDetails?.specialNeeds || '',

      // Applicant-specific fields
      previous_school: data.academicInfo?.previousSchool || '',
      wassce_index_number: data.academicInfo?.wassceIndexNumber || '',
      wassce_year: data.academicInfo?.wassceYear || '',
      // wassce_grades: data.academicInfo?.wassceGrades || '',
      wassce_grades: data.academicInfo?.wassceGrades
        ? typeof data.academicInfo.wassceGrades === 'string'
          ? data.academicInfo.wassceGrades
              .split(',')
              .map((s: any) => s.trim())  
              .filter((s: any) => s)      

          : data.academicInfo.wassceGrades
        : [],
      core_subjects_aggregate: data.academicInfo?.coreSubjectsAggregate || '',
      elective_subjects_aggregate: data.academicInfo?.electiveSubjectsAggregate || '',
      diploma_institution: data.academicInfo?.diplomaInstitution || '',
      diploma_program: data.academicInfo?.diplomaProgram || '',
      diploma_class: data.academicInfo?.diplomaClass || '',
      diploma_completion_year: data.academicInfo?.diplomaCompletionYear || '',
      diploma_gpa: data.academicInfo?.diplomaGpa || '',
      mature_exam_status: data.academicInfo?.matureExamStatus || '',
      mature_exam_date: this.formatDate(data.academicInfo?.matureExamDate),
      work_experience: data.academicInfo?.workExperience || '',
      years_of_experience: data.academicInfo?.yearsOfExperience || '',
      current_employer: data.academicInfo?.currentEmployer || '',
    };

    this.admissionRegistrationForm.patchValue(formValues, { emitEvent: false });

    this.selectedWassceGrades = formValues.wassce_grades || [];

    // FIX: Trigger region population for country of birth
    if (formValues.admissionCountryOfBirth) {
      console.log('Triggering region population for:', formValues.admissionCountryOfBirth);
      this.onCountryOfBirthChange(formValues.admissionCountryOfBirth);

      // Re-apply region after states are loaded
      setTimeout(() => {
        if (formValues.admissionRegion) {
          this.admissionRegistrationForm.patchValue(
            {
              admissionRegion: formValues.admissionRegion,
            },
            { emitEvent: false }
          );
          console.log('Region re-applied:', formValues.admissionRegion);
        }
        this.cd.detectChanges();
      }, 50);
    }

    // FIX: Trigger postal states population for postal country
    if (formValues.admissionCountry) {
      console.log('Triggering postal region population for:', formValues.admissionCountry);
      this.updatePostalStates(formValues.admissionCountry);

      // Re-apply postal state after states are loaded
      setTimeout(() => {
        if (formValues.admissionPostalStateRegion) {
          this.admissionRegistrationForm.patchValue(
            {
              admissionPostalStateRegion: formValues.admissionPostalStateRegion,
            },
            { emitEvent: false }
          );
          console.log('Postal region re-applied:', formValues.admissionPostalStateRegion);
        }
      }, 50);
    }

    if (formValues.programme_type && this.programmes.length > 0) {
      console.log('Triggering programme filter for:', formValues.programme_type);
      console.log('Selected programme:', formValues.admissionProgramme);

      this.selectedProgrammeType = formValues.programme_type;
      this.filterProgrammesByType(formValues.programme_type);

      setTimeout(() => {
        console.log('Filtered programmes:', this.filteredProgrammes);
        if (formValues.admissionProgramme) {
          this.admissionRegistrationForm.patchValue(
            {
              programme_type: formValues.programme_type,
              admissionProgramme: formValues.admissionProgramme,
            },
            { emitEvent: false }
          );
          console.log('Programme set to:', this.admissionRegistrationForm.get('admissionProgramme')?.value);
        }
      }, 100);
    }

    // Handle documents and URLs
  if (data.filePaths?.photoPath && !this.passportPhotoUrl) {
  this.passportPhotoUrl = data.filePaths.photoPath;
}
    if (data.filePaths?.academicTranscriptsPath) {
      this.admissionUploadedFileName = this.extractFileNameFromUrl(data.filePaths.academicTranscriptsPath);
    }

    console.log('Form populated successfully');

    this.admissionRegistrationForm.markAsPristine();
    this.applicantTypeForm.markAsPristine();
    this.saveFormDataToStorage();
  }

  private formatDate(dateString: string): string {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    } catch (error) {
      return '';
    }
  }

  private extractFileNameFromUrl(url: string): string {
    if (!url) return '';
    try {
      const parts = url.split('/');
      return parts[parts.length - 1] || 'Document.pdf';
    } catch (error) {
      return 'Document.pdf';
    }
  }

  logout(): void {
    this.hasUnsavedLocalChanges = false; 
    localStorage.removeItem('authToken');
    localStorage.removeItem('token');
    localStorage.removeItem('_act_ls');
    localStorage.removeItem('access_token');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('_act_ls');
    sessionStorage.removeItem('access_token');
    this.router.navigate(['/main-applcation-login']);
  }

  loadApplicationStatus(): void {
    const token = this.getAuthToken();
    this.applicantinfoservice.getApplicantStatus(token).subscribe({
      next: (response) => {
        this.applicationStatus = response.applicationStatus || 'Unknown';
      },
      error: (error) => {
        this.applicationStatus = 'Error loading status';
      },
    });
  }

  loadProgrammes(): void {
    this.isLoadingProgrammes = true;
    this.applicantinfoservice.ProgrammeList().subscribe({
      next: (programmes) => {
        this.programmes = programmes || [];

        // Initialize filtered programmes based on current selection
        const currentProgrammeType = this.admissionRegistrationForm.get('programme_type')?.value;
        if (currentProgrammeType) {
          this.filterProgrammesByType(currentProgrammeType);
        } else {
          this.filteredProgrammes = [...this.programmes];
        }

        this.isLoadingProgrammes = false;
      },
      error: (error) => {
        this.programmes = [];
        this.filteredProgrammes = [];
        this.isLoadingProgrammes = false;
      },
    });
  }


  loadRetrievedDocuments(): void {
  this.isLoadingDocuments = true;
  const token = this.getAuthToken();
  if (!token) {
    this.isLoadingDocuments = false;
    return;
  }

  this.applicantinfoservice.retrieveDocuments(token).subscribe({
    next: (response) => {
      if (response.success && response.documents) {
        this.retrievedDocuments = response.documents;

        if (response.documents.photo) {
          this.documentLoadingStates['photo'] = true;
          this.documentHandler.getSecureImageUrl(response.documents.photo, token).subscribe({
            next: (blobUrl) => {
              this.passportPhotoUrl = blobUrl;
              this.documentLoadingStates['photo'] = false;

  //               this.admissionRegistrationForm.patchValue({
  //   admissionPassportPhoto: blobUrl
  // }, { emitEvent: false });

            },
            error: (error) => {
              console.warn('Photo not available yet', error);
              this.documentLoadingStates['photo'] = false;
            },
          });
        }

        if (response.documents.academic_transcripts) {
          this.admissionUploadedFileName = this.extractFileNameFromUrl(response.documents.academic_transcripts);
        }
      }
      this.isLoadingDocuments = false;
    },
    error: (error) => {
      this.retrievedDocuments = {};
      this.isLoadingDocuments = false;
      console.warn('No documents retrieved yet - normal for new applications', error);
    },
  });
}


  // Find this method in your code and replace it with this version.
  private loadSecureImageUrl(key: string, documentType: string): void {
    const token = this.getAuthToken();
    if (!token) {
      console.error('Authentication token not found for secure image loading.');
      return;
    }
    // This is the correct call to your DocumentHandlerService.
    this.documentHandler.getSecureImageUrl(documentType, token).subscribe({
      next: (blobUrl) => {
        this.secureImageUrls[key] = blobUrl;
        if (key === 'photo') {
          this.passportPhotoUrl = blobUrl;
        }
      },
      error: (error) => {
        console.error(`Failed to load secure image for ${key}:`, error);
        this.toaster.error('Failed to load passport photo.', 'Error');
      },
    });
  }



  private displayRetrievedPhoto(documentPath: string): void {
  const token = this.getAuthToken();
  if (!token || !documentPath) {
    return;
  }

  this.documentHandler.getSecureImageUrl(documentPath, token).subscribe({
    next: (blobUrl) => {
      this.passportPhotoUrl = blobUrl;
    },
    error: (err) => {
      console.warn('Photo not available in this session', err);
    },
  });
}



  downloadDocument(url: string, filename?: string): void {
    if (!url) {
      this.toaster.error('Document URL not available', 'Download Error');
      return;
    }
    const token = this.getAuthToken();
    if (!token) {
      this.toaster.error('Authentication required for download', 'Download Error');
      return;
    }

    this.documentLoadingStates[url] = true;
    this.documentHandler.downloadDocument(url, token, filename).subscribe({
      next: (result) => {
        if (result.success) {
          this.toaster.success(result.message, 'Download');
        } else {
          this.toaster.error(result.message, 'Download Error');
        }
        this.documentLoadingStates[url] = false;
      },
      error: (error) => {
        this.toaster.error(error.message || 'Download failed', 'Download Error');
        this.documentLoadingStates[url] = false;
      },
    });
  }

  viewDocument(url: string): void {
    if (!url) {
      this.toaster.error('Document URL not available', 'View Error');
      return;
    }
    const token = this.getAuthToken();
    if (!token) {
      this.toaster.error('Authentication required to view document', 'View Error');
      return;
    }
    this.documentLoadingStates[url] = true;
    this.documentHandler.viewDocument(url, token).subscribe({
      next: (result) => {
        if (!result.success) {
          this.toaster.error(result.message, 'View Error');
        }
        this.documentLoadingStates[url] = false;
      },
      error: (error) => {
        this.toaster.error(error.message || 'Failed to open document', 'View Error');
        this.documentLoadingStates[url] = false;
      },
    });
  }

  isDocumentLoading(url: string): boolean {
    return this.documentLoadingStates[url] || false;
  }

  getSecureImageUrl(key: string): string | null {
    return this.secureImageUrls[key] || null;
  }

  selectApplicantType(type: 'SHS Graduate' | 'Diploma Holder' | 'Mature Applicant'): void {
    this.applicantTypeForm.patchValue({ applicantType: type });
    this.applicantTypeForm.get('applicantType')?.markAsTouched();
    this.selectedApplicantType = type;
    this.onApplicantTypeChange(type);
    this.saveFormDataToStorage();
  }

  onCountryOfBirthChange(countryName: string): void {
    console.log('Country of Birth changed to:', countryName);
    console.log('Available countries:', this.countries);

    if (countryName && this.countries?.length > 0) {
      const selectedCountry = this.countries.find((country) => country.name === countryName);
      console.log('Selected country object:', selectedCountry);

      this.availableStates = selectedCountry?.states || [];
      console.log('Available states/regions:', this.availableStates);

      // Clear the region field when country changes
      if (this.availableStates.length === 0) {
        this.admissionRegistrationForm.patchValue(
          {
            admissionRegion: '',
          },
          { emitEvent: false }
        );
      }
    } else {
      this.availableStates = [];
      this.admissionRegistrationForm.patchValue(
        {
          admissionRegion: '',
        },
        { emitEvent: false }
      );
    }
  }

  onPassportPhotoSelected(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    const fileList: FileList | null = element.files;

    console.log('Photo selection event triggered');
    console.log('Files from input:', fileList);

    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      console.log('Selected photo file:', file.name, file.size, file.type);

      // Set the actual File object in the form
      this.admissionRegistrationForm.patchValue({
        admissionPassportPhoto: file,
      });

      // Update the preview
      const reader = new FileReader();
      reader.onload = () => {
        this.passportPhotoUrl = reader.result;
      };
      reader.readAsDataURL(file);

      console.log(
        'Photo form control after setting:',
        this.admissionRegistrationForm.get('admissionPassportPhoto')?.value
      );
    } else {
      this.clearPassportPhoto();
    }
  }

  clearPassportPhoto(): void {
    this.passportPhotoUrl = null;
    this.admissionRegistrationForm.patchValue({ admissionPassportPhoto: null });
    const fileInput = document.getElementById('passportPhoto') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onApplicantTypeChange(applicantType: 'SHS Graduate' | 'Diploma Holder' | 'Mature Applicant' | null): void {
    console.log('Applicant type changed to:', applicantType);
    this.selectedApplicantType = applicantType;

    this.clearAllApplicantSpecificValidators();
    this.clearApplicantSpecificFieldValues();

    if (applicantType) {
      this.setValidatorsForApplicantType(applicantType);
      this.admissionRegistrationForm.updateValueAndValidity();
    }
  }

  debugPhotoUpload(): void {
    const photoControl = this.admissionRegistrationForm.get('admissionPassportPhoto');
    const docControl = this.admissionRegistrationForm.get('admissionDocuments');
    console.log('=== PHOTO UPLOAD DEBUG hapened ===');
    console.log('Photo Constructor:', photoControl?.value?.constructor?.name);
    console.log('Document Constructor:', docControl?.value?.constructor?.name);
    console.log('Passport Photo URL:', this.passportPhotoUrl);
    console.log('=== END DEBUG  happened===');
  }

  private clearAllApplicantSpecificValidators(): void {
    const allApplicantFields = [
      'previous_school',
      'wassce_index_number',
      'wassce_grades',
      'wassce_year',
      'core_subjects_aggregate',
      'elective_subjects_aggregate',
      'diploma_institution',
      'diploma_program',
      'diploma_class',
      'diploma_completion_year',
      'diploma_gpa',
      'mature_exam_status',
      'work_experience',
      'mature_exam_date',
      'years_of_experience',
      'current_employer',
    ];
    allApplicantFields.forEach((fieldName) => {
      const control = this.admissionRegistrationForm.get(fieldName);
      if (control) {
        control.clearValidators();
        control.setErrors(null);
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  private clearApplicantSpecificFieldValues(): void {
    const fieldsToDefaults: { [key: string]: any } = {
      previous_school: '',
      wassce_index_number: '',
      wassce_grades: [],
      wassce_year: '',
      core_subjects_aggregate: '',
      elective_subjects_aggregate: '',
      diploma_institution: '',
      diploma_program: '',
      diploma_class: '',
      diploma_completion_year: '',
      diploma_gpa: '',
      mature_exam_status: '',
      work_experience: '',
      mature_exam_date: '',
      years_of_experience: '',
      current_employer: '',
    };
    Object.entries(fieldsToDefaults).forEach(([controlName, defaultValue]) => {
      this.selectedWassceGrades = [];
      const control = this.admissionRegistrationForm.get(controlName);
      if (control) {
        control.setValue(defaultValue, { emitEvent: false });
        control.markAsUntouched();
        control.markAsPristine();
      }
    });
  }

  private setValidatorsForApplicantType(applicantType: 'SHS Graduate' | 'Diploma Holder' | 'Mature Applicant'): void {
    switch (applicantType) {
      case 'SHS Graduate':
        this.setValidatorsForSHS();
        break;
      case 'Diploma Holder':
        this.setValidatorsForDiploma();
        break;
      case 'Mature Applicant':
        this.setValidatorsForMature();
        break;
    }
  }

  private setValidatorsForSHS(): void {
    const shsFields = {
      previous_school: [Validators.required],
      wassce_index_number: [Validators.required],
      wassce_grades: [Validators.required],
      wassce_year: [Validators.required, Validators.pattern(/^\d{4}$/)],
      core_subjects_aggregate: [Validators.required, Validators.min(3), Validators.max(48)],
      elective_subjects_aggregate: [Validators.required, Validators.min(3), Validators.max(36)],
    };
    Object.entries(shsFields).forEach(([fieldName, validators]) => {
      const control = this.admissionRegistrationForm.get(fieldName);
      if (control) {
        control.setValidators(validators);
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  private setValidatorsForDiploma(): void {
    const diplomaFields = {
      diploma_institution: [Validators.required],
      diploma_program: [Validators.required],
      diploma_class: [Validators.required],
      diploma_completion_year: [Validators.required, Validators.pattern(/^\d{4}$/)],
      diploma_gpa: [Validators.required, Validators.min(0), Validators.max(5)],
    };
    Object.entries(diplomaFields).forEach(([fieldName, validators]) => {
      const control = this.admissionRegistrationForm.get(fieldName);
      if (control) {
        control.setValidators(validators);
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  private setValidatorsForMature(): void {
    const matureFields = {
      // mature_exam_status: [Validators.required],
      work_experience: [Validators.required],
      // mature_exam_date: [Validators.required],
      years_of_experience: [Validators.required, Validators.min(1)],
      current_employer: [Validators.required],
    };
    Object.entries(matureFields).forEach(([fieldName, validators]) => {
      const control = this.admissionRegistrationForm.get(fieldName);
      if (control) {
        control.setValidators(validators);
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  onProgrammeTypeChange(programmeType: string): void {
    this.selectedProgrammeType = programmeType;
    this.filterProgrammesByType(programmeType);

    this.admissionRegistrationForm.patchValue({
      admissionProgramme: '',
    });
  }


  private filterProgrammesByType(programmeType: string): void {
  if (!programmeType || !this.programmes.length) {
    this.filteredProgrammes = [];
    return;
  }

  this.filteredProgrammes = this.programmes.filter((programme) => {
    const programmeName = programme.programmeType?.toLowerCase() || '';

    switch (programmeType) {
      case 'Undergraduate':
        return (
          programmeName.startsWith('bachelor') ||
          /\bbsc\b/.test(programmeName) ||
          /\bb\.a\b/.test(programmeName) ||
          /\bb\.ed\b/.test(programmeName) ||
          /\bbtech\b/.test(programmeName) ||
          programmeName.startsWith('undergraduate')
        );

      case 'Diploma':
        return (
          programmeName.startsWith('diploma') ||
          /\bhnd\b/.test(programmeName) ||
          programmeName.includes('higher national diploma')
        );

      case 'Certificate':
        return programmeName.startsWith('certificate');

      default:
        return true;
    }
  });
}



  matchAdmissionPasswords(control: any): { [key: string]: any } | null {
    const password = this.admissionRegistrationForm?.get('admissionPassword')?.value;
    const confirmPassword = control.value;
    return password === confirmPassword ? null : { mismatch: true };
  }

 
  isAdmissionStepValid(stepNumber: number): boolean {
  if (stepNumber === 0) {
    return this.applicantTypeForm.valid;
  }

  if (stepNumber === 4) {
    const photoControl = this.admissionRegistrationForm.get('admissionPassportPhoto');
    const hasNewPhotoFile  = photoControl?.value instanceof File;
    const hasExistingPhoto = !!(this.passportPhotoUrl);
    return hasNewPhotoFile || hasExistingPhoto;
  }

  const fieldsToValidate =
    this.admissionStepValidationGroups[stepNumber as keyof typeof this.admissionStepValidationGroups] || [];
  const specificFields  = this.getApplicantSpecificFields();
  const filteredFields  = fieldsToValidate.filter((field) => !specificFields.includes(field));
  return (
    this.areAdmissionFieldsValid(filteredFields) &&
    this.areAdmissionFieldsValid(this.getRequiredApplicantFields())
  );
}



  private getRequiredApplicantFields(): string[] {
    switch (this.selectedApplicantType) {
      case 'SHS Graduate':
        return [
          'previous_school',
          'wassce_index_number',
          'wassce_grades',
          'wassce_year',
          'core_subjects_aggregate',
          'elective_subjects_aggregate',
        ];
      case 'Diploma Holder':
        return ['diploma_institution', 'diploma_program', 'diploma_class', 'diploma_completion_year', 'diploma_gpa'];
      case 'Mature Applicant':
        return [ 'work_experience', 'years_of_experience', 'current_employer'];
      default:
        return [];
    }
  }

  private getApplicantSpecificFields(): string[] {
    return [
      'previous_school',
      'wassce_index_number',
      'wassce_grades',
      'wassce_year',
      'core_subjects_aggregate',
      'elective_subjects_aggregate',
      'diploma_institution',
      'diploma_program',
      'diploma_class',
      'diploma_completion_year',
      'diploma_gpa',
      'mature_exam_status',
      'work_experience',
      'mature_exam_date',
      'years_of_experience',
      'current_employer',
    ];
  }

  areAdmissionFieldsValid(fieldNames: string[]): boolean {
    return fieldNames.every((fieldName) => {
      const control = this.admissionRegistrationForm.get(fieldName);
      return control ? control.valid : true;
    });
  }

  canAccessAdmissionStep(stepNumber: number): boolean {
    return stepNumber <= this.maxAdmissionStepReached;
  }

  goToAdmissionStep(stepNumber: number): void {
    if (stepNumber === 6) {
      this.currentAdmissionStep = stepNumber;
      this.saveFormDataToStorage();
      return;
    }
    if (this.canAccessAdmissionStep(stepNumber)) {
      this.currentAdmissionStep = stepNumber;
      this.saveFormDataToStorage();
    } else {
      this.toaster.error(`Please complete step ${this.maxAdmissionStepReached} before proceeding`, 'Error');
    }
  }

  onAdmissionContinue(): void {
    if (this.currentAdmissionStep === 0) {
      if (this.applicantTypeForm.valid) {
        this.currentAdmissionStep++;
        this.maxAdmissionStepReached = Math.max(this.maxAdmissionStepReached, this.currentAdmissionStep);
        this.saveFormDataToStorage();
      } else {
        this.toaster.info(`Please select an applicant type to continue`, 'Information');
        this.markAdmissionStepFieldsAsTouched(this.currentAdmissionStep);
      }
    } else {
      if (this.isAdmissionStepValid(this.currentAdmissionStep)) {
        if (this.currentAdmissionStep < this.admissionSidebarSteps.length - 1) {
          this.currentAdmissionStep++;
          this.maxAdmissionStepReached = Math.max(this.maxAdmissionStepReached, this.currentAdmissionStep);
          this.saveFormDataToStorage();
        } else {
          this.onAdmissionSubmit();
        }
      } else {
        this.toaster.info(`Please fill in all required fields correctly before proceeding.`, 'Information');
        this.markAdmissionStepFieldsAsTouched(this.currentAdmissionStep);
      }
    }
  }

  previousAdmissionStep(): void {
    if (this.currentAdmissionStep > 0) {
      this.currentAdmissionStep--;
      this.saveFormDataToStorage();
    } else {
      this.onAdmissionBackToLogin();
    }
  }

  markAdmissionStepFieldsAsTouched(stepNumber: number): void {
    const fieldsToTouch =
      this.admissionStepValidationGroups[stepNumber as keyof typeof this.admissionStepValidationGroups] || [];
    fieldsToTouch.forEach((fieldName) => {
      const control = this.admissionRegistrationForm.get(fieldName);
      if (control) {
        control.markAsTouched();
      }
    });
    if (stepNumber === 0) {
      this.applicantTypeForm.markAllAsTouched();
    }
  }

  getAdmissionStepStatus(stepNumber: number): 'completed' | 'active' | 'disabled' {
    if (this.applicationStatus && this.applicationStatus !== 'Draft' && stepNumber !== 6) {
      return 'disabled';
    }
    if (stepNumber === 6) {
      return 'active';
    } else if (stepNumber < this.currentAdmissionStep) {
      return 'completed';
    } else if (stepNumber === this.currentAdmissionStep) {
      return 'active';
    } else if (stepNumber <= this.maxAdmissionStepReached) {
      return 'active';
    } else {
      return 'disabled';
    }
  }

  toggleAdmissionPasswordVisibility(field: 'password' | 'confirmPassword'): void {
    if (field === 'password') {
      this.admissionPasswordVisible = !this.admissionPasswordVisible;
    } else {
      this.admissionConfirmPasswordVisible = !this.admissionConfirmPasswordVisible;
    }
  }

  onAdmissionFileSelected(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    const fileList: FileList | null = element.files;

    console.log('Document selection event triggered');
    console.log('Files from input:', fileList);

    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      console.log('Selected document file:', file.name, file.size, file.type);

      // Set the actual File object in the form - THIS IS CRITICAL
      this.admissionRegistrationForm.patchValue({
        admissionDocuments: file,
      });

      // Update the filename display
      this.admissionUploadedFileName = file.name;

      console.log(
        'Document form control after setting:',
        this.admissionRegistrationForm.get('admissionDocuments')?.value
      );
      console.log('Document is File?', this.admissionRegistrationForm.get('admissionDocuments')?.value instanceof File);
    } else {
      this.clearAdmissionFile();
    }
  }

  clearAdmissionFile(): void {
    this.admissionUploadedFileName = '';
    this.admissionRegistrationForm.patchValue({ admissionDocuments: null });
    const fileInput = document.getElementById('admissionDocuments') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  refreshApplicationStatus(): void {
    this.loadApplicationStatus();
  }

  getAuthToken(): string {
    const possibleTokens = [
      localStorage.getItem('authToken'),
      localStorage.getItem('token'),
      localStorage.getItem('_act_ls'),
      localStorage.getItem('access_token'),
      sessionStorage.getItem('authToken'),
      sessionStorage.getItem('token'),
      sessionStorage.getItem('_act_ls'),
      sessionStorage.getItem('access_token'),
    ];
    let token = possibleTokens.find((t) => t !== null) || '';
    if (token && token.startsWith('{')) {
      try {
        const parsed = JSON.parse(token);
        token = parsed.access_token || parsed.token || parsed.authToken || parsed.accessToken || token;
      } catch (e) {}
    }
    return token;
  }

  getFormValidationErrors(): any {
    const formErrors: any = {};
    Object.keys(this.admissionRegistrationForm.controls).forEach((key) => {
      const controlErrors = this.admissionRegistrationForm.get(key)?.errors;
      if (controlErrors) {
        formErrors[key] = controlErrors;
      }
    });
    return formErrors;
  }

  onAdmissionSubmit(): void {
    this.debugPhotoUpload();
    this.loading = true;
    this.isSubmittingFlag = true;

   const isAdmissionFormValid = this.admissionRegistrationForm.valid;
const isApplicantTypeFormValid = this.applicantTypeForm.valid;
const isPhotoStepValid = this.isAdmissionStepValid(4);


if (!isAdmissionFormValid || !isApplicantTypeFormValid || !isPhotoStepValid) {
  this.loading = false;
  this.isSubmittingFlag = false;
  this.markAllAdmissionFieldsAsTouched(this.admissionRegistrationForm);
  this.applicantTypeForm.markAllAsTouched();
  this.toaster.error('Please fill in all required fields before submitting.', 'Validation Error');
  return;
}

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.submissionError = null;
    this.submissionSuccess = false;

    const token = this.getAuthToken();
    if (!token) {
      this.isSubmitting = false;
      this.submissionError = 'Authentication token is missing. Please log in again.';
      this.toaster.error('Please log in again to submit your application.', 'Authentication Error');
      return;
    }

    const formValue = this.admissionRegistrationForm.value;
    // Get files directly from form controls instead of serialized values
    const preservedPhotoFile = this.admissionRegistrationForm.get('admissionPassportPhoto')?.value;
    const preservedDocFile = this.admissionRegistrationForm.get('admissionDocuments')?.value;

    console.log('Preserving files before submission:', {
      photo: preservedPhotoFile,
      photoIsFile: preservedPhotoFile instanceof File,
      doc: preservedDocFile,
      docIsFile: preservedDocFile instanceof File,
    });

    const applicantType = this.applicantTypeForm.get('applicantType')?.value;
    const applicantData: any = {
      id: {
        applicantType: applicantType,
      },
      personalInfo: {
        title: formValue.admissionTitle || '',
        lastName: formValue.admissionSurname,
        firstName: formValue.admissionFirstName,
        middleName: formValue.admissionMiddleName || '',
        othername: formValue.admissionOtherNames || '',
        dateOfBirth: formValue.admissionDob,
        gender: formValue.admissionGender,
        nationality: formValue.admissionNationality,
        postalcountry: formValue.admissionCountry,
        countryofbirth: formValue.admissionCountryOfBirth,
        cityortownofbirth: formValue.admissionCityOfBirth,
        religion: formValue.admissionReligion || '',
        hometown: formValue.admissionHometown,
      },
      contactInfo: {
        email: formValue.admissionEmail,
        phoneNumber: formValue.admissionTelephone,
        alternatePhone: formValue.alternate_phone || '',
        postalAddress: formValue.admissionAddressLine1,
        postalAddresstwo: formValue.admissionAddressLine2 || '',
        postalCodendigaddress: formValue.admissionPostalCodenDigitalAddress || '',
        residentialAddress: formValue.residential_address || '',
        postalStateRegion: formValue.admissionPostalStateRegion || '',
        region: formValue.admissionRegion,
        city: formValue.admissionCity,
      },
      emergencyContact: {
        emergencyContactName: formValue.emergency_contact_name || '',
        emergencyContactPhone: formValue.emergency_contact_phone || '',
        emergencyContactRelationship: formValue.emergency_contact_relationship || '',
      },
      academicInfo: {
        programmeAppliedFor: formValue.admissionProgramme,
        programmeType: formValue.programme_type,
        preferredStudyMode: formValue.preferred_study_mode || '',
        academicYear: formValue.academic_year,
        otherQualifications: formValue.other_qualifications || '',
        professionalCertifications: formValue.professional_certifications || '',
        languageProficiency: formValue.language_proficiency || '',
      },
      applicationDetails: {
        feePaymentMode: formValue.fee_payment_mode,
        scholarshipApplied: formValue.scholarship_applied,
        scholarshipType: formValue.scholarship_type || '',
        medicalConditions:
          formValue.admissionHealthCondition === 'Yes' ? formValue.admissionHealthConditionDetails : null,
        disabilities: formValue.disabilities || '',
        specialNeeds: formValue.special_needs || '',
        applicationStatus: 'Submitted',
        applicationDate: null,
      },
    };
    if (applicantType === 'SHS Graduate') {
      applicantData.academicInfo.previousSchool = formValue.previous_school;
      applicantData.academicInfo.wassceIndexNumber = formValue.wassce_index_number;
      applicantData.academicInfo.wassceYear = formValue.wassce_year ? parseInt(formValue.wassce_year) : null;
      // applicantData.academicInfo.wassceGrades = formValue.wassce_grades;
      applicantData.academicInfo.wassceGrades = formValue.wassce_grades ? formValue.wassce_grades.join(', ') : '';
      applicantData.academicInfo.coreSubjectsAggregate = formValue.core_subjects_aggregate
        ? parseInt(formValue.core_subjects_aggregate)
        : null;
      applicantData.academicInfo.electiveSubjectsAggregate = formValue.elective_subjects_aggregate
        ? parseInt(formValue.elective_subjects_aggregate)
        : null;
      applicantData.academicInfo.diplomaInstitution = '';
      applicantData.academicInfo.diplomaProgram = '';
      applicantData.academicInfo.diplomaClass = '';
      applicantData.academicInfo.diplomaCompletionYear = null;
      applicantData.academicInfo.diplomaGpa = null;
      applicantData.academicInfo.matureExamStatus = '';
      applicantData.academicInfo.matureExamDate = null;
      applicantData.academicInfo.workExperience = '';
      applicantData.academicInfo.yearsOfExperience = null;
      applicantData.academicInfo.currentEmployer = '';
    } else if (applicantType === 'Diploma Holder') {
      applicantData.academicInfo.diplomaInstitution = formValue.diploma_institution;
      applicantData.academicInfo.diplomaProgram = formValue.diploma_program;
      applicantData.academicInfo.diplomaClass = formValue.diploma_class;
      applicantData.academicInfo.diplomaCompletionYear = formValue.diploma_completion_year
        ? parseInt(formValue.diploma_completion_year)
        : null;
      applicantData.academicInfo.diplomaGpa = formValue.diploma_gpa ? parseFloat(formValue.diploma_gpa) : null;
      applicantData.academicInfo.previousSchool = '';
      applicantData.academicInfo.wassceIndexNumber = '';
      applicantData.academicInfo.wassceYear = null;
      applicantData.academicInfo.wassceGrades = '';
      applicantData.academicInfo.coreSubjectsAggregate = null;
      applicantData.academicInfo.electiveSubjectsAggregate = null;
      applicantData.academicInfo.matureExamStatus = '';
      applicantData.academicInfo.matureExamDate = null;
      applicantData.academicInfo.workExperience = '';
      applicantData.academicInfo.yearsOfExperience = null;
      applicantData.academicInfo.currentEmployer = '';
    } else if (applicantType === 'Mature Applicant') {
      // applicantData.academicInfo.matureExamStatus = formValue.mature_exam_status;
      // applicantData.academicInfo.matureExamDate = formValue.mature_exam_date;
      applicantData.academicInfo.workExperience = formValue.work_experience;
      applicantData.academicInfo.yearsOfExperience = formValue.years_of_experience
        ? parseInt(formValue.years_of_experience)
        : null;
      applicantData.academicInfo.currentEmployer = formValue.current_employer;
      applicantData.academicInfo.previousSchool = '';
      applicantData.academicInfo.wassceIndexNumber = '';
      applicantData.academicInfo.wassceYear = null;
      applicantData.academicInfo.wassceGrades = '';
      applicantData.academicInfo.coreSubjectsAggregate = null;
      applicantData.academicInfo.electiveSubjectsAggregate = null;
      applicantData.academicInfo.diplomaInstitution = '';
      applicantData.academicInfo.diplomaProgram = '';
      applicantData.academicInfo.diplomaClass = '';
      applicantData.academicInfo.diplomaCompletionYear = null;
      applicantData.academicInfo.diplomaGpa = null;
    }
    applicantData.filePaths = {
      photoPath: '',
      birthCertificatePath: '',
      academicTranscriptsPath: '',
      recommendationLettersPath: '',
      personalStatementPath: '',
    };
    if (this.currentApplicantId) {
      applicantData.id.applicantId = this.currentApplicantId;
    }

    this.isSubmittingFlag = true;

    this.applicantinfoservice.saveorupdateApplicant(applicantData, token).subscribe({
      next: (response) => {
        console.log('Data saved successfully, now uploading files with preserved objects');

        const formValueWithFiles = {
          ...formValue,
          admissionPassportPhoto: preservedPhotoFile,
          admissionDocuments: preservedDocFile,
        };

        console.log('Calling handleFileUploads with preserved files:', {
          photo: formValueWithFiles.admissionPassportPhoto,
          photoIsFile: formValueWithFiles.admissionPassportPhoto instanceof File,
          doc: formValueWithFiles.admissionDocuments,
          docIsFile: formValueWithFiles.admissionDocuments instanceof File,
        });

        this.loading = false;

        this.handleFileUploads(formValueWithFiles, token);
      },
      error: (saveError) => {
        this.isSubmittingFlag = false;
        this.isSubmitting = false;
        this.loading = false;
        this.handleSubmissionError(saveError);
      },
    });
  }

  private handleFileUploads(formValue: any, token: string): void {
    console.log('=== HANDLE FILE UPLOADS DEBUG ===');
    console.log('Full formValue received:', formValue);

      const passportPhotoFile = formValue.admissionPassportPhoto instanceof File
    ? formValue.admissionPassportPhoto
    : this.admissionRegistrationForm.get('admissionPassportPhoto')?.value;

  const otherDocumentFile = formValue.admissionDocuments instanceof File
    ? formValue.admissionDocuments
    : this.admissionRegistrationForm.get('admissionDocuments')?.value;


    console.log('Photo file from form control:', passportPhotoFile);
    console.log('Photo is File?', passportPhotoFile instanceof File);
    console.log('Photo constructor:', passportPhotoFile?.constructor?.name);

    console.log('Document file from form control:', otherDocumentFile);
    console.log('Document is File?', otherDocumentFile instanceof File);
    console.log('Document constructor:', otherDocumentFile?.constructor?.name);

    const uploadRequests = [];

    if (passportPhotoFile instanceof File) {
      console.log('Adding photo to upload queue:', passportPhotoFile.name, passportPhotoFile.size);
      uploadRequests.push(
        this.applicantinfoservice.uploadDocument(passportPhotoFile, 'photo', token).pipe(
          tap((response) => console.log('📸 Photo upload response:', response)),
          catchError((error) => {
            console.error('Photo upload error:', error);
            return throwError(() => error);
          })
        )
      );
    } else {
      console.warn('Photo is NOT a File object, skipping upload. Value:', passportPhotoFile);
      console.warn('Photo type:', typeof passportPhotoFile);
    }

    if (otherDocumentFile instanceof File) {
      console.log('Adding document to upload queue:', otherDocumentFile.name, otherDocumentFile.size);
      uploadRequests.push(
        this.applicantinfoservice.uploadDocument(otherDocumentFile, 'academic_transcripts', token).pipe(
          tap((response) => console.log('Document upload response:', response)),
          catchError((error) => {
            console.error('Document upload error:', error);
            return throwError(() => error);
          })
        )
      );
    } else {
      console.warn('Document is NOT a File object, skipping upload. Value:', otherDocumentFile);
      console.warn('Document type:', typeof otherDocumentFile);
    }

    console.log('Total upload requests:', uploadRequests.length);

    if (uploadRequests.length > 0) {
      forkJoin(uploadRequests)
        .pipe(
          finalize(() => {
            this.isSubmitting = false;
            this.isSubmittingFlag = false;
          })
        )
        .subscribe({
          next: (responses) => {
            console.log('All uploads completed:', responses);
            this.handleSuccessfulSubmission();
          },
          error: (error) => {
            console.error('Upload error:', error);
            this.submissionError =
              'Application data saved, but some files failed to upload. You can try uploading them again later.';
            this.handleSuccessfulSubmission();
          },
        });
    } else {
      console.log('No files to upload - finishing submission');
      this.isSubmitting = false;
      this.isSubmittingFlag = false;
      this.handleSuccessfulSubmission();
    }
  }

  private handleSubmissionError(saveError: any): void {
    let errorMessage = 'Submission failed. ';
    if (saveError.status) {
      switch (saveError.status) {
        case 401:
          errorMessage = 'Session expired or invalid token. Please log in again.';
          break;
        case 403:
          errorMessage = 'Access denied. Please check your permissions.';
          break;
        case 400:
          errorMessage = 'Invalid data provided. Please check your form entries.';
          break;
        case 500:
          errorMessage = 'Server error. Please try again later.';
          break;
        default:
          errorMessage = `Server responded with error ${saveError.status}. Please try again.`;
      }
    }
    if (saveError.error && saveError.error.message) {
      errorMessage += ` Details: ${saveError.error.message}`;
    }
    this.submissionError = errorMessage;
    this.toaster.error(errorMessage);
  }

  private handleSuccessfulSubmission(): void {
    this.submissionSuccess = true;
     this.hasUnsavedLocalChanges = false;
    this.currentAdmissionStep = 6;
    this.maxAdmissionStepReached = Math.max(this.maxAdmissionStepReached, this.currentAdmissionStep);

    // NOW reload the application status and data (after files are uploaded)
    this.loadApplicationStatus();

    // Add a small delay to ensure files are processed on server
    setTimeout(() => {
      this.loadApplicantDataWithRetry();
    }, 1000);

    this.toaster.success('Your application has been submitted successfully!');
    this.clearFormDataFromStorage();
  }

  private isSubmittingFlag = false;

  markAllAdmissionFieldsAsTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if ((control as any).controls) {
        this.markAllAdmissionFieldsAsTouched(control as FormGroup);
      }
    });
  }

  onAdmissionBackToLogin(): void {
    this.toaster.success('Navigate back to login from admission form');
  }

  getAdmissionApplicationSummary() {
    const formValue = this.admissionRegistrationForm.value;
    return {
      applicantType: this.selectedApplicantType,
      personalInfo: {
        title: formValue.admissionTitle,
        fullName:
          `${formValue.admissionSurname} ${formValue.admissionFirstName} ${formValue.admissionMiddleName} ${formValue.admissionOtherNames}`.trim(),
        gender: formValue.admissionGender,
        dateOfBirth: formValue.admissionDob,
        birthPlace: `${formValue.admissionCityOfBirth}, ${formValue.admissionCountryOfBirth}`,
        nationality: formValue.admissionNationality,
        religion: formValue.admissionReligion,
        hometown: formValue.admissionHometown,
        region: formValue.admissionRegion,
        emergencyContactName: formValue.emergency_contact_name,
        emergencyContactPhone: formValue.emergency_contact_phone,
        emergencyContactRelationship: formValue.emergency_contact_relationship,
      },
      contactInfo: {
        postalAddress: formValue.admissionAddressLine1,
        postalAddresstwo: formValue.admissionAddressLine2,
        residentialAddress: formValue.residential_address,
        city: formValue.admissionCity,
        postalStateRegion: formValue.admissionPostalStateRegion,
        country: formValue.admissionCountry,
        postalCodendigaddress: formValue.admissionPostalCodenDigitalAddress,
        telephone: formValue.admissionTelephone,
        alternatePhone: formValue.alternate_phone,
      },
      programmeInfo: {
        programme: formValue.admissionProgramme,
        programmeType: formValue.programme_type,
        preferredStudyMode: formValue.preferred_study_mode,
        academicYear: formValue.academic_year,
        otherQualifications: formValue.other_qualifications,
        professionalCertifications: formValue.professional_certifications,
        languageProficiency: formValue.language_proficiency,
      },
      healthInfo: {
        healthCondition: formValue.admissionHealthCondition,
        healthDetails: formValue.admissionHealthConditionDetails,
        disabilities: formValue.disabilities,
        specialNeeds: formValue.special_needs,
      },
      financialInfo: {
        feePaymentMode: formValue.fee_payment_mode,
        scholarshipApplied: formValue.scholarship_applied,
        scholarshipType: formValue.scholarship_type,
      },
      shsDetails:
        this.selectedApplicantType === 'SHS Graduate'
          ? {
              school: formValue.previous_school,
              index: formValue.wassce_index_number,
              // grades: formValue.wassce_grades,
              grades: formValue.wassce_grades ? formValue.wassce_grades.join(', ') : '',
              wassceYear: formValue.wassce_year,
              coreAggregate: formValue.core_subjects_aggregate,
              electiveAggregate: formValue.elective_subjects_aggregate,
            }
          : null,
      diplomaDetails:
        this.selectedApplicantType === 'Diploma Holder'
          ? {
              institution: formValue.diploma_institution,
              program: formValue.diploma_program,
              class: formValue.diploma_class,
              completionYear: formValue.diploma_completion_year,
              gpa: formValue.diploma_gpa,
            }
          : null,
      matureDetails:
        this.selectedApplicantType === 'Mature Applicant'
          ? {
              examStatus: formValue.mature_exam_status,
              experience: formValue.work_experience,
              examDate: formValue.mature_exam_date,
              yearsOfExperience: formValue.years_of_experience,
              currentEmployer: formValue.current_employer,
            }
          : null,
      admissionStatus: this.applicationStatus || 'Pending',
    };
  }

  async downloadApplicationPDF(): Promise<void> {
    this.isGeneratingPDF = true;
    try {
      await this.pdfDownloadService.downloadApplicationPDF(() => this.getAdmissionApplicationSummary(), this.toaster);
    } finally {
      this.isGeneratingPDF = false;
    }
  }


  onSessionLogin(): void {
  this.showSessionExpiredModal = false;
  this.sessionService.redirectToLogin(this.router);
}

}
